import {Inject, Injectable, Optional} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {Config} from '../../common/config';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  constructor(@Optional() @Inject('IS_MOBILE_DEVICE') private isMobileServer: boolean) {
    if (isPlatformBrowser(Config.platformId)) {
      this.isMobileServer = /Mobile|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    }
  }

  isMobile(): boolean {
    return this.isMobileServer;
  }
}
